import React, { useState, useEffect } from "react";

/**
 * Simple Math CAPTCHA Component
 * Génère des additions simples et faciles
 */
export default function SimpleCaptcha({ onValidate, resetTrigger }) {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState(0);
  const [userAnswer, setUserAnswer] = useState("");
  const [isValid, setIsValid] = useState(false);

  // Générer une nouvelle question mathématique simple
  const generateQuestion = React.useCallback(() => {
    // Addition simple: un nombre entre 1-15 + un nombre entre 1-15
    const num1 = Math.floor(Math.random() * 15) + 1; // 1-15
    const num2 = Math.floor(Math.random() * 15) + 1; // 1-15
    const correctAnswer = num1 + num2;

    setQuestion(`${num1} + ${num2}`);
    setAnswer(correctAnswer);
    setUserAnswer("");
    setIsValid(false);
    onValidate(false);
  }, [onValidate]);

  // Initialiser au montage du composant
  useEffect(() => {
    generateQuestion();
  }, [resetTrigger, generateQuestion]);

  // Vérifier la réponse
  const handleAnswerChange = (e) => {
    const value = e.target.value;
    setUserAnswer(value);

    const valid = parseInt(value) === answer;
    setIsValid(valid);
    onValidate(valid);
  };

  return (
    <div className="space-y-2">
      <label className="block text-sm font-semibold text-slate-800 dark:text-slate-200">
        🔒 Security Verification
      </label>

      <div className="rounded-lg bg-gradient-to-br from-emerald-50 to-teal-50 dark:from-slate-800 dark:to-slate-700 p-4 border-2 border-emerald-200 dark:border-emerald-700">
        <p className="text-xs text-slate-600 dark:text-slate-300 mb-2">
          Please solve this to verify you're human:
        </p>

        <div className="flex items-center gap-3">
          <div className="flex-1 bg-white dark:bg-slate-900 rounded-md px-4 py-3 border-2 border-slate-200 dark:border-slate-600">
            <p className="text-xl font-bold text-center text-slate-800 dark:text-slate-100 font-mono">
              {question} = ?
            </p>
          </div>
        </div>

        <div className="flex gap-2 items-center mt-3">
          <input
            type="number"
            value={userAnswer}
            onChange={handleAnswerChange}
            onFocus={(e) => e.target.select()}
            placeholder="Your answer"
            className={`flex-1 rounded-md border-2 px-4 py-2.5 text-base font-semibold transition-all ${
              userAnswer
                ? isValid
                  ? "border-green-500 bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-400"
                  : "border-red-500 bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-400"
                : "border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100"
            }`}
            required
          />
          <button
            type="button"
            onClick={generateQuestion}
            className="rounded-md bg-emerald-600 hover:bg-emerald-700 px-4 py-2.5 text-white font-medium transition-colors shadow-sm"
            title="New question"
          >
            🔄
          </button>
        </div>

        {userAnswer && (
          <div className="mt-2 flex items-center gap-2">
            {isValid ? (
              <p className="text-sm font-medium text-green-600 dark:text-green-400 flex items-center gap-1">
                <span className="text-lg">✓</span> Correct! You're verified
              </p>
            ) : (
              <p className="text-sm font-medium text-red-600 dark:text-red-400 flex items-center gap-1">
                <span className="text-lg">✗</span> Incorrect, please try again
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
